<div class="loading active" id="loading-init" *ngIf="loading$ | async">
  <div class="loading-inner">
      <div class="page-spinner"></div><span>Cargando...</span>
  </div>
</div>
